<!--
 * @Description: 成绩学生考试成绩 修改
 * @Author: ZSC
 * @Date: 2023-04-21 11:40:29.679
 * @LastEditors: PF
 * @LastEditTime: 2023-08-08 13:59:56
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期">
              <el-select v-model="xqid" placeholder="学期" @change="xveqichaxvn(1)" style="width: 220px;" disabled filterable>
                <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试计划" prop="ksjhid">
              <el-select @change="xveqichaxvn(2)" v-model="ruleForm.ksjhid" placeholder="考试计划" style="width:220px" disabled filterable>
                <el-option v-for="(item) in kaoshirenwu" :key="item.id" :label="item.ksmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试科目" prop="kmid">
              <el-select @change="xveqichaxvn(3)" v-model="ruleForm.kmid" placeholder="考试科目" style="width:220px" disabled filterable>
                <el-option v-for="(item) in kaoshikemu" :key="item.kskmid" :label="item.kskmmc" :value="item.kskmid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考号/学号" prop="kh">
              <el-input v-model="ruleForm.kh" @blur="xvesheng" placeholder="考号/学号" style="max-width:220px" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分数" prop="fs">
              <el-input v-model="ruleForm.fs" placeholder="分数" style="max-width:220px" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学生姓名:">
              {{xsxx.xm}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级:">
              {{xsxx.xzbmc}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学号:">
              {{xsxx.xh}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import {
  submitEditForm,
  closeWindow,
  loadData,
  loadSelect
} from '@/api/common.js'
// import { loadZiDianSelect } from '@/api/queryZiDian.js'
// import { loadJiGouCascader } from '@/api/queryJiGou.js'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const xqid = ref()
const kaoshirenwu = ref() // 考试任务
const kaoshikemu = ref() // 考试科目
const allXq = ref()
const xsxx = ref({
  xm: '',
  xzbmc: '',
  xh: ''
}) // 学生信息
const xs = ref()
const xvesheng = () => {
  if (ruleForm.value.kh) {
    const info = { kh: ruleForm.value.kh, ksrwid: ruleForm.value.ksrwid }
    loadSelect({
      url: '/api/v2/jiaowu/chengjikaoshirenwu/kaohao',
      data: xs,
      parms: info,
      loadSuccess: function (res) {
        xsxx.value = {
          xm: res.data.xm,
          xzbmc: res.data.xzbmc,
          xh: res.data.xh
        }
      }
    })
  }
}
const xveqichaxvn = (e) => {
  if (e === 1) {
    ruleForm.value.ksrwid = ''
    ruleForm.value.kmid = ''
    getkaoshirenwu()
    getkaoshikemu()
  } else if (e === 2) {
    ruleForm.value.kmid = ''
    getkaoshikemu()
  }
}
// 审核状态
const shztData = ref({ list: [] })
loadSelect({
  url: '/api/v2/jiaowu/kaowukaoshijihua/shenhezhuangtai',
  data: shztData
})
// 考试任务
const getkaoshirenwu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/list',
    data: kaoshirenwu,
    parms: {
      ksxqid: ruleForm.value.ksxqid,
      shzt: shztData.value.shenHeTongGuo
    },
    order: 'ksksrq',
    sort: 'asc',
    loadSuccess: function (res) {
      getkaoshikemu()
    }
  })
}
// 考试科目
const getkaoshikemu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/kemu/list',
    data: kaoshikemu,
    parms: { ksjhid: ruleForm.value.ksjhid },
    order: 'kskmmc',
    sort: 'asc'
  })
}

watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: allXq,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              xqid.value = element.id
              getkaoshirenwu()
            }
          })
        }
      })
      loadData({
        url:
          '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/' +
          props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.kh = `${res.data.kh}/${res.data.xsxh}`
          xqid.value = res.data.xqid
          xsxx.value = {
            xm: res.data.xsxm,
            xzbmc: res.data.xsbjmc,
            xh: res.data.xsxh
          }
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitEditForm({
    url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/chengji',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
